<template>
  <div class="topic-file-preview-unavailable">
    <img alt="" aria-hidden="true" class="topic-file-preview-unavailable__icon" :src="fileIcon" />
    <div class="topic-file-preview-unavailable__text">
      <p class="topic-file-preview-unavailable__title">该文件格式暂不支持预览</p>
      <p class="topic-file-preview-unavailable__description">可下载后在本地查看</p>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'OtherBody'
})

defineProps({
  fileIcon: {
    type: String,
    required: true
  }
})
</script>

<style lang="scss" scoped>
.topic-file-preview-unavailable {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 140px;
  padding: 16px 20px;
  box-sizing: border-box;
  background: #f5f7fb;
  font-family: 'PingFang SC', sans-serif;
  text-align: center;

  &__icon {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    object-fit: contain;
  }

  &__text {
    margin-top: 16px;
  }

  &__title {
    margin: 0;
    color: #000000;
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
  }

  &__description {
    margin: 4px 0 0;
    color: #646d7d;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }
}
</style>
